import React from "react";
import IsolationPermitStepPage from "./IsolationPermitStepPage";

function CetificateIsolation(props) {
  return <IsolationPermitStepPage {...props} step="isolation_certificate" />;
}

export default CetificateIsolation;
